import {
    SET_EXAMS,
    OPEN_EXAM_EDIT,
    CLOSE_EXAM_EDIT,
    SET_EXAM_EDIT,
    RESET_EXAM_EDIT,
    SET_APPLICANT_EXAMS,
    OPEN_EXAM_DELETE,
    CLOSE_EXAM_DELETE,
    SET_EXAM_DELETE,
    RESET_EXAM_DELETE,
} from '../store/actionTypes';

export const exams = (state = [], action) => {
    switch (action.type) {
        case SET_EXAMS:
            return action.payload;
        default:
            return state;
    }
};

export const examEditStatus = (state = false, action) => {
    switch (action.type) {
        case OPEN_EXAM_EDIT:
            return true;
        case CLOSE_EXAM_EDIT:
            return false;
        default:
            return state;
    }
};

const examEditDefault = {
    id: 0, exam_id: 0, type: 0, ball: 0,
};
export const examEdit = (state = examEditDefault, action) => {
    switch (action.type) {
        case SET_EXAM_EDIT:
            return action.payload;
        case RESET_EXAM_EDIT:
            return examEditDefault;
        default:
            return state;
    }
};

export const applicantExams = (state = [], action) => {
    switch (action.type) {
        case SET_APPLICANT_EXAMS:
            return action.payload;
        default:
            return state;
    }
};

export const examDeleteStatus = (state = false, action) => {
    switch (action.type) {
        case OPEN_EXAM_DELETE:
            return true;
        case CLOSE_EXAM_DELETE:
            return false;
        default:
            return state;
    }
};

const examDeleteDefault = null;
export const examDelete = (state = examDeleteDefault, action) => {
    switch (action.type) {
        case SET_EXAM_DELETE:
            return action.payload;
        case RESET_EXAM_DELETE:
            return examDeleteDefault;
        default:
            return state;
    }
};
